<template>
  <v-card class="px-3 live-trade-details-card rounded-0" elevation="0"
    :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row dense>
      <v-col cols="12">
        <v-sheet
          class="d-flex align-center mb-lg-4 mb-md-2 mb-2 py-3 px-1 justify-center justify-sm-space-between userBriefHistory flex-column flex-sm-row text-center text-sm-left"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
          <div class="title d-flex align-center">
            <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
            <span>IB / Partner Rejected</span>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row class="no-gutters align-center pr-1">
      <v-col cols="12" sm="12" md="5" lg="7">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="4">
             <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="1">
        <ul class="mt-0">
          <li>
            <span class="">Request</span>
            <span>{{ totalRejectedRequest || 0 }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="allrejected" :server-items-length="rejectIbPagination?.total || 10"
              :options.sync="options" :loading="rejectIbIsLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.details="{ item }">
                <router-link class="links text-decoration-none" :to="`/registered-user-details/${item?.id}`">
                  <v-icon color="#039de9" small>
                    mdi-eye-outline
                  </v-icon>
                </router-link>
              </template>
              <template v-slot:item.fullname="{ item }" v-if="$canRoute('create-new-user-account') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.id}`">
                  {{ item.fullname }}
                </router-link>
              </template>
              <template v-slot:item.fullname="{ item }" v-else>
                {{ item.fullname }}
              </template>
              <template v-slot:item.countries="{ item }">
                {{ item?.countries?.name || "N/A" }}
              </template>
              <template v-slot:item.admin_name="{ item }">
                {{ item?.ibActionBy?.fname || "N/A" }}
              </template>
              <template v-slot:item.mobile="{ item }">
                {{ item?.mobile || "N/A" }}
              </template>
              <template v-slot:item.created_at="{ index, item }">
                {{ formatMySQLDate(item?.created_at)}}
              </template>
                <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.ClientVisibility="{ item }">
                      <div class="text-danger">
                       Rejected
                      </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { IBREQUEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
    search: "",
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
       isCopied: false,
      copiedStates: {},
      modal: false,
      dialog: false,
      headers: [
        { text: "Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Country", value: "countries" },
        { text: "Mobile No.", value: "mobile" },
        { text: "Reg. Time", value: "created_at" },
        { text: "Action by", value: "admin_name" },
        { text: "IB Status", value: "ClientVisibility" },
      ],
    };
  },

  computed: {
    ...mapState("ibrequest", ['allrejected', 'totalRejectedRequest','rejectIbIsLoading', 'rejectIbPagination']),
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },

  methods: {
    formatMySQLDate,
    ...mapActions("ibrequest", [
      IBREQUEST__ACTIONS.ALLREJECTEDIBREQUEST
    ]),
     obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
     copyText(item) {
      navigator.clipboard.writeText(item?.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
    getTextColor(item) {
      return item.class;
    },
    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[IBREQUEST__ACTIONS.ALLREJECTEDIBREQUEST](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
     getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

 async created() {
  await this.fetchData();
  if (this.$canRoute('partner-list') === 1) {
    this.headers.push({ text: "Details", value: "details" });
  }
},
};
</script>
